var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('OwnerBusinessesView',{attrs:{"is_loading":_vm.is_loading,"is_in_admin_view":true},on:{"set-page-attributes":_vm.on_set_page_attributes}})}
var staticRenderFns = []

export { render, staticRenderFns }